<template>
	<div class="independent-wrapper">
		<div class="content">
			<div class="title">
				<span class="border"></span>
				<i class="el-icon-location-outline"></i> 知识库管理 > 图片管理
			</div>
			<div class="contentLeft">
				<div class="tab-container tab">
					<ul>
						<li v-for="(item, index) in tabList" :key="index" :class="{ active: currentTabIndex == index }"
							@click="goOther(index, item.id)">
							{{ item.name }}
						</li>
					</ul>
				</div>
				<div class="con">
					<div class="search-con">
						<el-form :inline="true" :model="searchData" class="demo-form-inline">
							<el-form-item class="el-form-item-line" style="margin-left: 10px;">
								<el-input class="longInput" v-model="searchData.name" placeholder="输入图片名称查询"></el-input>
							</el-form-item>
							<el-form-item class="el-form-item-line" style="margin-left: 10px;">
								<el-button size="large"  @click="reset">
									<el-icon class="el-icon--right"><RefreshRight /></el-icon>
									重置
								</el-button> 
								<el-button size="large"  class="searchBtn" @click="searchPluse">
									<el-icon class="el-icon--right"><Search /></el-icon>
									查询
								</el-button>
								<el-button size="large" class="addBtn" @click="add">上传图片</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="table-con consiliaTable">
						<el-table ref="multipleTable" :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
							tooltip-effect="dark" style="width: 100%" :data="tableListData">
							<el-table-column align="center" label="序号" prop="seq" width="80">
							</el-table-column>
							<el-table-column align="center" label="图片" prop="path">
								<template #default="{row}">
									<div class="about">
										<img style="width:60px" :src="globalImageUrl + row.path" />
									</div>
								</template>
							</el-table-column>
							<el-table-column align="center" label="名称" prop="name">
							</el-table-column>
							<el-table-column align="center" label="添加时间" prop="createTime">
							</el-table-column>

							<el-table-column align="center" label="操作" width="100">
								<template #default="{row}">
									<span class="editor" @click="edit(row)">
										编辑
									</span>
									<span class="del" @click="del(row)">
										删除
									</span>
								</template>
							</el-table-column>
						</el-table>
						<div class="des">
							<div class="right" style="margin-right: 0;">
								<div class="page">
									<el-pagination @current-change="handleCurrentChange"
										:current-page="currentPage" layout="prev, pager, next, jumper"
										:total="total"></el-pagination>
								</div>
								<div class="data">
									共
									<span>{{ pages }}</span>页/ <span>{{ total }}</span>条记录
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="dialog">
			<el-dialog :title="addOrEdit == 'add' ? '新增图片' : '编辑图片'" v-model="addUserFlag" center>
				<div class="con">
					<el-form ref="addUserForm" :model="addUserForm" :rules="rules" label-width="80px">
						<div class="item">
							<div class="line">
								<el-form-item label="图片上传" prop="path">
									<el-upload class="upload-demo" drag action=" " :before-remove="handleRemove"
										:http-request="getFile" accept=".png,.PNG,.jpg,.JPG,.JPEG,.jpeg"
										:file-list="fileList">
										<i class="el-icon-upload"></i>
										<div class="el-upload__text">
											将文件拖到此处，或<em>点击上传</em>
											<br />
											<span style="font-size: 12px;color: #ccc;">支持jpg/png格式上传,文件大小不超过20M</span>
										</div>
									</el-upload>
								</el-form-item>

								<el-form-item label="图片名称" prop="name">
									<el-input class="longInput" v-model="addUserForm.name"></el-input>
								</el-form-item>
							</div>
						</div>
					</el-form>
				</div>
				<template class="dialog-footer" #footer>
					<el-button size="large" @click="cancelPatient">取 消</el-button>
					<el-button size="large" class="addBtn" type="primary" @click="addPatient('addUserForm')">确 定</el-button>
				</template>
			</el-dialog>
		</div>
	</div>
</template>
<script>
	import globle from "../../globle/globle"
	export default {
		
		data() {
			return {
				total: 0,
				currentPage: 1,
				pages: 1,
				role: "",
				tabList: [{
						id: 0,
						name: "饮食推荐",
					},
					{
						id: 1,
						name: "体质管理",
					},
					{
						id: 2,
						name: "选项维护",
					},
					{
						id: 3,
						name: "健康评估",
					},
					{
						id: 4,
						name: "穴位维护",
					},
					{
						id: 5,
						name: "运动健康",
					},
					{
						id: 6,
						name: "药食管理",
					},
					{
						id: 7,
						name: "图片管理",
					},
					{
						id: 8,
						name: "视频管理",
					},
				],
				currentTabIndex:7,
				searchData: {
					name: "", //脉诊结果
				},
				fileData: null, //文件
				fileList: [],
				fileObj: null,
				tableListData: [],
				pulseList: [],
				addUserForm: {
					name: "",
					path: "",
					id: "",
				},
				rules: {
					path: [{
						required: true,
						message: "请选择上传图片",
						trigger: "change",
					}, ],
					name: [{
						required: true,
						message: "请输入图片名称",
						trigger: "blur",
					}, ],
				},
				addOrEdit: "",
				addUserFlag: false,
				globalImageUrl: globle.imgPath,
				imageUrl: "",
			};
		},

		methods: {
			//路由切换
			goOther(index, id) {
				this.currentTabIndex = index;
				if (index == 0) {
					this.$router.push({
						path: "/knowledgeManagement/dietRecommend",
					});
				}
				if (index == 1) {
					this.$router.push({
						path: "/knowledgeManagement/constituteManagement",
					});
				}
				if (index == 2) {
					this.$router.push({
						path: "/knowledgeManagement/optionManagement",
					});
				}
				if (index == 3) {
					this.$router.push({
						path: "/knowledgeManagement/healthAssessment",
					});
				}
				if (index == 4) {
					this.$router.push({
						path: "/knowledgeManagement/physiothMainten",
					});
				}
				if (index == 5) {
					this.$router.push({
						path: "/knowledgeManagement/sportsHealth",
					});
				}
				if (index == 6) {
					this.$router.push({
						path: "/knowledgeManagement/drugManagement",
					});
				}
				if (index == 7) {
					this.$router.push({
						path: "/knowledgeManagement/picManagement",
					});
				}
				if (index == 8) {
					this.$router.push({
						path: "/knowledgeManagement/videoManagement",
					});
				}
			},
			getFile(file) {
				var fileObj = file.file;
				this.fileObj = fileObj;
				const isLt20M = fileObj.size / 1024 / 1024 < 20;
				if (!isLt20M) {
					this.$message.error("上传文件的大小不能超过20M!");
					return false;
				}
				this.fileList = [];
				// FormData 对象
				this.fileList.push({
					name: fileObj.name,
					url: fileObj.url,
				});
				this.addUserForm.name = fileObj.name.split(".")[0];
				this.fileData = new FormData(); //  用FormData存放上传文件
				this.fileData.append("file", fileObj);
				this.uploadFile();
			},
			//封面上传
			uploadFile() {
				this.$multipartPost("/business/base/image/upload", this.fileData)
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.imageUrl = res.data.msg;
							this.addUserForm.path = res.data.msg;
						} else {
							alert(res.data.msg);
						}
					})
					.catch((Error) => {
						console.log(Error);
					});
			},
			//删除文件
			handleRemove() {
				return false;
			},

			//新增脉象
			add() {
				this.addUserFlag = true;
				this.fileList = [];
				this.addUserForm = {
					name: "",
					createTime: "",
					path: "",
					id: "",
				};
				this.addOrEdit = "add";
			},
			//编辑脉象
			edit(item) {
				//console.log(item)
				this.addUserFlag = true;
				this.addUserForm = {
					name: item.name,
					createTime: item.createTime,
					path: item.path,
					id: item.id,
				};
				this.fileList = [];
				var obj = {
					name: item.name,
					url: item.path,
				};
				this.fileList.push(obj);
				this.fileData = new FormData();
				this.addOrEdit = "edit";
			},
			//删除脉象
			del(item) {
				this.$confirm("此操作将删除该条记录, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						this.delUserInfo(item.id);
					})
					.catch(() => {});
			},
			//取消
			cancelPatient() {
				this.addUserFlag = false;
			},
			//确定
			addPatient(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.addOrEdit == "add") {
							this.addUserInfo();
						}
						if (this.addOrEdit == "edit") {
							this.editUserInfo();
						}
					} else {
						console.log("error submit!!");
						return false;
					}
				});
			},
			//新增脉象接口
			addUserInfo() {
				this.$applicationJson("/business/base/image/add", {
						name: this.addUserForm.name,
						createTime: "",
						path: this.imageUrl,
						id: "",
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
						}
						this.getPlanList(this.currentPage);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//页码跳转
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getPlanList(this.currentPage);
			},
			//编辑脉象接口
			editUserInfo() {
				this.$applicationJson("/business/base/image/edit", {
						name: this.addUserForm.name,
						createTime: this.addUserForm.createTime,
						path: this.addUserForm.path,
						id: this.addUserForm.id,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
						}
						this.getPlanList(this.currentPage);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//删除
			delUserInfo(id) {
				let ids = [];
				ids.push(id);
				this.$applicationJson("/business/base/image/delete", {
						ids: ids,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
						}
						this.getPlanList(this.currentPage);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			reset(){
				this.searchData.name = '';
				this.getPlanList(0);
			},
			//搜索
			searchPluse() {
				this.getPlanList(0);
				this.currentPage = 0;
			},
			//获取脉象列表
			getPlanList(currentPage) {
				this.$applicationJson("/business/base/image/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name: this.searchData.name,
						},
						size: 10,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.tableListData = res.data.data.records;
							for (let i = 0; i < this.tableListData.length; i++) {
								this.tableListData[i].seq = Number(i) + 1;
							}
							this.total = res.data.data.total;
							this.pages = res.data.data.pages;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
		},
		created() {
			this.$nextTick(() => {
				let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
				let role = loginInfo.role;
				this.role = role;
				if (role == 1) {
					this.tabList.splice(0, 5);
				}
				this.getPlanList(0);
			});
		},
	};
</script>

<style lang="less" scoped="scoped">
	@import "../../../static/css/layout.less";
	@import "../../../static/css/mentor.less";

	.independent-wrapper {
		.content {
			.contentLeft {
				width: 100%;
				height: calc(100% - 40px);

				.con {
					min-height: calc(100% - 80px);

					.search-con {
						height: 60px;
					}
				}
			}

			.about {
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;

				img {
					margin: 0 auto;
				}
			}

			.demo-form-inline {
				margin-top: 10px;

				:deep(.el-input__inner){
					width: 220px;
				}
			}

			.editor {
				cursor: pointer;
				color: #679ff6;
			}

			.del {
				color: #df6d78;
				cursor: pointer;
				margin-left: 10px;
			}

		}
	}

	.dialog {
		.el-dialog__body {
			.con {
				margin-top: 30px;
				height: auto;

				.item {
					.line {
						width: 100%;
						overflow: hidden;

						&:nth-child(1) {
							margin-bottom: 20px;
						}

						.el-form-item {
							width: 100%;
						}

						.dialog-tit {
							height: 40px;
							line-height: 40px;

							span {
								float: left;
								font-size: 16px;
								margin-bottom: 20px;
								overflow: hidden;
								width: 100%;
								color: #333;
							}

							.border {
								background-color: rgba(103, 159, 246, 1);
								width: 3px;
								height: 14px;
								margin-top: 13px;
								position: absolute;
								left: 0px;
							}
						}
					}
				}

				.longInput {
					width: 100%;

					:deep(.el-input__inner){
						width: 100%;
					}
				}

				.smallInput {
					width: 150px;

					:deep(.el-input__inner){
						width: 100%;
					}
				}
			}
		}
	}
</style>
